export default __webpack_public_path__ + "media/zurb/img/services/process/lead-img-433f64425efa0c121690ab0759be970b.png";